import React, { useEffect, useRef, useState } from "react";
import SappchatLogo from "common/SappchatLogo";
import styled from "styled-components";
import { useNavigate, useLocation } from "react-router-dom";
import ConnectWallet from "components/ConnectWallet";
import Hamburger from "common/Hamburger";
import { animated, config, useSpring } from "react-spring";
import SappchatImg from "assets/sappchat-logo.png";

const NAV_ARR = [
  {
    id: 0,
    title: "Home",
    route: "/",
  },
  {
    id: 1,
    title: "About",
    route: "/about",
  },
  {
    id: 2,
    title: "Tokenomics",
    route: "/tokenomic",
  },
  {
    id: 3,
    title: "HODLAPP",
    route: "/hodlapp",
  },
  {
    id: 4,
    title: "Contact",
    route: "/contact",
  },
];

const Navigation = () => {
  const navigate = useNavigate();

  const mobileMenuRef = useRef(null);

  let location = useLocation();

  const [openMobileMenu, setOpenMobileMenu] = useState<boolean>(false);

  const props = useSpring({
    config: {
      duration: 275,
    },
    from: { x: -10000 },
    to: { x: 0 },
  });

  const closeModal = (e: any) => {
    if (mobileMenuRef.current === e.target) {
      setOpenMobileMenu(false);
    }
  };

  return (
    <>
      <NavWrapper>
        <SappchatLogo
          logoText
          logoWidth={48}
          logoHeight={48}
          handleClick={() => navigate("/")}
        />

        <NavList>
          {/* {NAV_ARR.map((item: any, idx: number) => {
            return (
              <NavItem
                key={item.id}
                onClick={() => navigate(item.route)}
                style={{
                  borderBottom:
                    location?.pathname === item.route
                      ? "2px solid #fff"
                      : "2px solid transparent",
                }}
              >
                {item.title}
              </NavItem>
            );
          })} */}
        </NavList>
        <ConnectDiv>
          <ConnectWallet />
        </ConnectDiv>
      </NavWrapper>

      <NavMobileWrapper onClick={closeModal} ref={mobileMenuRef}>
        <Hamburger onClick={() => setOpenMobileMenu((prev) => !prev)} />
        <ConnectDiv>
          <ConnectWallet />
        </ConnectDiv>

        {openMobileMenu && (
          <>
            <MobileMenu style={{ left: openMobileMenu ? 0 : -10000 }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <img src={SappchatImg} alt="sappchat-logo" />{" "}
                <span
                  style={{
                    marginLeft: "0.5rem",
                    color: "#fff",
                    fontSize: "1.5rem",
                    fontWeight: 600,
                  }}
                >
                  Sappchat
                </span>
              </div>
              <NavListMobile>
                {/* {NAV_ARR.map((item: any, idx: number) => {
                  return (
                    <NavItemMobile
                      key={item.id}
                      onClick={() => navigate(item.route)}
                      style={{
                        borderBottom:
                          location?.pathname === item.route
                            ? "2px solid #fff"
                            : "2px solid transparent",
                      }}
                    >
                      {item.title}
                    </NavItemMobile>
                  );
                })} */}
              </NavListMobile>
            </MobileMenu>
            <OutsideMobileMenu onClick={closeModal} ref={mobileMenuRef} />
          </>
        )}
      </NavMobileWrapper>
    </>
  );
};

export default Navigation;

const NavWrapper = styled.div`
  padding: 2rem;
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  grid-gap: 2rem;
  align-items: center;

  @media (max-width: 426px) {
    display: none;
  }
`;

const NavMobileWrapper = styled.div`
  display: none;
  padding: 2rem;

  @media (max-width: 426px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  @media (max-width: 320px) {
    padding: 0.5rem;
  }
`;

const NavList = styled.ul`
  display: grid;
  grid-template-columns: repeat(6, auto);
  justify-content: center;
  grid-column-gap: inherit;
  white-space: nowrap;

  @media (max-width: 1024px) {
    grid-gap: 0.5rem;
  }
`;

const NavItem = styled.li`
  list-style-type: none;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  border-top: 2px solid transparent;
  transition: 0.275s;

  &:hover {
    border-bottom: 2px solid #fff !important;
    border-top: 2px solid #fff !important;
  }
`;

const NavListMobile = styled.ul`
  white-space: nowrap;
  margin: 0.5rem 0;
`;
const NavItemMobile = styled.li`
  list-style-type: none;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  border-top: 2px solid transparent;
  transition: 0.275s;

  margin: 0.5rem 0;

  &:hover {
    border-bottom: 2px solid #fff !important;
  }
`;

const ConnectDiv = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const MobileMenu = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  height: 100vh;
  width: 50vw;

  background: ${(p) => p.theme.secondary};

  background: #1d4160;
  border-top-right-radius: 14px;
  border-bottom-right-radius: 14px;
  box-shadow: 0 0 5px 2.5px rgb(92 92 92 / 65%);

  padding: 1rem;

  img {
    @media (max-width: 426px) {
      width: 36px;
    }
  }

  transition: 0.5s;
  animation-delay: 0.5s;
`;

const OutsideMobileMenu = styled.div`
  width: 50vw;
  background: transparent;

  position: fixed;
  top: 0;
  left: 50vw;
  height: 100vh;
`;
